import { ButtonTriggerEvent } from '../../../common/components';
import { HubEvent } from '../../../models/hub/hub.event';

export class EditEventModalActions {
    confirm: (event: ButtonTriggerEvent, e: HubEvent, image: string) => void;
    cancel?: () => void;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.event.modal/edit.event.modal.provider.ts